import { ListItemInfo } from 'theSource/components';
import { Contact } from 'theSource/features/Contacts/types';

export const mapItems = (contacts: Contact[]): ListItemInfo[] =>
  contacts.map((contact) => ({
    title: contact.title,
    name: contact.name,
    path: contact.id.toString(),
  }));
